<template>
  <!-- class="lg:flex flex-1" -->
  <div>
    <Nav />
    <toTopComponent />
    <contentsDetailPage class="main" />
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/new/Nav.vue";
import toTopComponent from "@/components/toTopComponent.vue";
import contentsDetailPage from "@/pages/contentsMall/contentsDetailPage.vue";
import Footer from "@/components/new/Footer.vue";

export default {
  name: "contentsDetail",
  components: { contentsDetailPage, Nav, toTopComponent, Footer },
};
</script>

<style scoped>
.main {
  min-height: calc(100vh - var(--nav-height, 80px));
  margin-top: var(--nav-height, 80px);
}
</style>
